import React, { Fragment } from "react";
import { Row, Col } from "antd";

const DetailPreview = ({
  detailInfo,
  labelClass,
  valueClass,
  inlineFlex,
  labelStyle,
  valueStyle,
  className,
}) => {
  const columnSpan = {
    ...(!inlineFlex && { md: 6 }),
  };

  return (
    detailInfo.length > 0 &&
    detailInfo.map((item, index) => {
      const {
        label,
        value,
        valueItemStyle,
        viewClass,
        labelItemClass,
        valueItemClass,
        borderBottom,
        hideLabel,
        hideInfo
      } = item;

      if(hideInfo) return null;
      
      if (inlineFlex) {
        return (
          <Fragment key={label ?? index}>
            <div
              className={`view-detail-content flex align-center justify-between ${
                className || ""
              }`}
            >
              {!hideLabel && (
                <div
                  className={`${labelItemClass || labelClass || ""}`}
                  style={labelStyle || {}}
                >
                  {label}
                </div>
              )}
              <div
                className={`${valueItemClass || valueClass || ""}`}
                style={valueItemStyle || valueStyle || {}}
              >
                {value}
              </div>
            </div>

            {borderBottom && <div className="border-divider mt-8 mb-8" />}
          </Fragment>
        );
      }

      return (
        <Row
          className={`view-detail-content ${viewClass || label}`}
          key={label}
        >
          <Col {...columnSpan} className={labelClass || ""}>
            {label}
          </Col>

          <Col {...columnSpan} className={valueClass || ""}>
            {value}
          </Col>
        </Row>
      );
    })
  );
};

export default DetailPreview;
